import MediaItem from './media-items/media-item';
import { TYPE_VIDEO } from '@/utils/case-types';

export default class CaseVideo {
  constructor(data) {
    this.fullwidth = null;
    this.alttext = null;
    this.vimeourl = null;
    this.thumbnail = [];
    this.mobilethumbnail = [];
    this.type = TYPE_VIDEO;
    // Initialize data
    if (data) {
      Object.assign(this, {
        fullwidth: data.Fullwidth,
        alttext: data.AltText,
        vimeourl: data.VimeoUrl,
        thumbnail: new MediaItem(data.Thumbnail),
        mobilethumbnail: new MediaItem(data.MobileThumbnail)
      });
    }
  }
}



// WEBPACK FOOTER //
// src/entities/case/case-video.js